import { frFR } from './fr-FR.lang';
import { enUS } from './en-US.lang';

export var Lang =
{
    'fr-FR': frFR,
    'en-US': enUS
}